module.exports = __webpack_public_path__ + "static/img/brain.72aa312.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/brain.jpg
// module id = u/Rt
// module chunks = 1